import type { ReactNode } from "react";

const SOCIAL_BUTTON_CLASS =
  "flex flex-1 items-center justify-center rounded-lg border border-grey-200 bg-white px-3 py-2 shadow-flat hover:bg-grey-50 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50";

export function SocialLinkButton({
  children,
  className,
  ...rest
}: {
  children: ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a className={[SOCIAL_BUTTON_CLASS, className].filter(Boolean).join(" ")} {...rest}>
      {children}
    </a>
  );
}

export function GoogleIcon() {
  return <img src="/brand/sso/google.svg" alt="" aria-hidden className="size-6" />;
}

export function GitHubIcon() {
  return <img src="/brand/sso/github.svg" alt="" aria-hidden className="size-6" />;
}

export function MicrosoftIcon() {
  return <img src="/brand/sso/microsoft.svg" alt="" aria-hidden className="size-6" />;
}

export function OktaIcon() {
  return <img src="/brand/sso/okta.svg" alt="" aria-hidden className="size-6" />;
}
